// extracted by mini-css-extract-plugin
module.exports = {"appLoader":"styles_appLoader__3xheM","ringrotate-loader":"styles_ringrotate-loader__3QyN3"};